// extracted by mini-css-extract-plugin
module.exports = {"SimpleCard":"SimpleCard_SimpleCard__ivF6e"};